<template>
    <div>
        <div v-if="props.value && props.value.name">
            {{ props.value.name }}
        </div>
        <div v-if="props.value && props.value.street">
            {{ props.value.street }}
        </div>
        <div v-if="props.value && props.value.city">
            {{ props.value.city }}
        </div>
        <div v-if="props.value && props.value.zipCode">
            {{ props.value.zipCode }}
        </div>
        <div v-if="props.value && props.value.phone">
            {{ props.value.phone }}
        </div>
        <div v-if="props.value && props.value.email">
            {{ props.value.email }}
        </div>
    </div>
</template>

<script setup lang="ts">
import type { GridComponent } from '@src/Common/Components/types';

const props = withDefaults(defineProps<GridComponent>(), {});
//
</script>
